import { render } from "./UploadDocument.vue?vue&type=template&id=1446e94e"
import script from "./UploadDocument.vue?vue&type=script&lang=js"
export * from "./UploadDocument.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\Vind\\Vind\\FomoFront\\VindFrontFomoApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QUploader from 'quasar/src/components/uploader/QUploader.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QSpace,QBtn,QUploader});qInstall(script, 'directives', {ClosePopup});
